import { FACE_CARD_SMALL_URLS } from '../components/FaceCardArt';

/**
 * Warm the browser's HTTP cache with the small face-card artwork so the very
 * first hand a user is dealt renders instantly. Uses Image() rather than
 * <link rel=prefetch> so the browser also decodes the bitmap eagerly.
 *
 * Safe to call multiple times — Image() requests are coalesced by the cache.
 * Called once on app mount; runs in an idle callback so it never competes
 * with the critical render path.
 */
export function prefetchFaceCards() {
  const run = () => {
    for (const url of FACE_CARD_SMALL_URLS) {
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    }
  };
  if (typeof window === 'undefined') return;
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(run, { timeout: 4000 });
  } else {
    setTimeout(run, 800);
  }
}
